import React, { Component } from 'react';
import {
	Button,
	Modal,
	ModalBody,
	ModalHeader,
	ModalFooter,
	Col,
	Row,
	Container,
} from 'reactstrap';
import { Formik, Form } from 'formik';
import { BlockUiContext } from '../../Providers/BlockUi';

import './ErroImpressaoGuiasEmitidas.scss';

class ErroImpressaoGuiasEmitidas extends Component {
  constructor(props) {
		super(props);

		this.state = { 
			isOpen: false,
			listaErro: []
		 };

		this.formik = React.createRef();
		
	}

  toggleModal = () => {
		this.setState({ isOpen: !this.state.isOpen });
	};

	openModal = () => {
		this.setState({ isOpen: true });
	};

	closeModal = () => {
		this.setState({ isOpen: false });
	};

  render() {
		const { listErro } = this.props;
		
    return (
      <Modal id="modalErroImprimir" toggle={this.closeModal} isOpen={this.state.isOpen} backdrop="static">
        <BlockUiContext.Consumer>
					{blockUi => {
						this.onLoading = blockUi.handleLoading;
					}}
				</BlockUiContext.Consumer>
        <Formik
          ref={this.formik}
					initialValues={this.initialValues}
					validationSchema={this.validationSchema}
					validateOnChange={false}
					onSubmit={this.handleSubmit}
        >
          {formikProps => {
            const { values, errors, touched } = formikProps;
            return (
              <Form>
								<ModalHeader>Erro ao imprimir!</ModalHeader>
								<ModalBody>
									<Container>
										<Row>
											<Col>
												{listErro.map(erro =>(
													<p key={erro} style={{ color: 'red' }}> - {erro}</p>
												))}
												<p>
                        A impressão não é possível no momento. Aguarde alguns minutos e acesse ao link abaixo:
												</p>
                        <a href="http://www.gnre.pe.gov.br/gnre/v/guia/index" target="_blank">Portal GNRE</a>
											</Col>
										</Row>
									</Container>
								</ModalBody>
								<ModalFooter>
									<Container>
										<Row className="justify-content-md-center">
											<Col xs="3">
												<Button 
                          color="info" 
                          onClick={this.closeModal}
                        >
													Fechar
												</Button>
											</Col>
                    </Row>
									</Container>
								</ModalFooter>
							</Form>
            );
          }}
        </Formik>
      </Modal>
    );
  }
}

export default ErroImpressaoGuiasEmitidas;